import React from "react";
import "../App.css";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import Guideline from "../Asset/circled-g-_1_.svg";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Moment from "moment";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Modal from "react-bootstrap/Modal";
import { GetEquipmentInfo } from "../helpers/api";
import {
  downloadStatus,
  getEquipmentHistory,
  getEquipmentInfo,
} from "../Actions/ShipEquipmentDetailsAPI";
import { getEquipmentServiceTypeList } from "../Actions/CommonAPI";
import * as moment from "moment";
import { DownloadAttachment } from "../Actions/AttachmentAPI";
import swal from "sweetalert";
import i18n from "./DropdownLanguage/i18n";

class EquipmentCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
      rows: 10,
      first2: 0,
      rows2: 10,
      modalIsOpen: false,
      modalIsOpendownload: false,
      downloadArray: [],
      currentdoctype: ""
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    console.log(this.props.arraylist, 'test')
  }

  renderPopover(props) {
    const { t } = this.props;
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label>{t("ShipEquipmentStatusScreen.DownloadLastServiceReport")}</label>
        </Popover.Content>
      </Popover>
    );
  }

  renderGPopover(props) {
    const { t } = this.props;
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label>{t("ShipEquipmentStatusScreen.DownloadGuidelines")}</label>
        </Popover.Content>
      </Popover>
    );
  }
  renderMPopover(props) {
    const { t } = this.props;
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label>{t("EquipmentManagementScreenContent.DownloadEquipmentManual")}</label>
        </Popover.Content>
      </Popover>
    );
  }
  renderWPopover(props) {
    const { t } = this.props;
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          {/* <label>{t("EquipmentManagementScreenContent.DownloadEquipmentManual")}</label> */}
          <label>Download Work Procedure</label>

        </Popover.Content>
      </Popover>
    );
  }
  renderView(props) {
    const { t } = this.props;
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label>{t("ShipDetailsScreen.EquipmentDetails")}</label>
        </Popover.Content>
      </Popover>
    );
  }

  renderPopover2(props) {
    const { t } = this.props;
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label>{t("content.MoreInformation")}</label>
        </Popover.Content>
      </Popover>
    );
  }
  renderViewequip(props) {
    const { t } = this.props;
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label>{t("PendingShipScreenContent.ViewEquipmentDetails")}</label>
        </Popover.Content>
      </Popover>
    );
  }



  ShowRightPanel = (id, item) => {
    console.log(item);

    this.props.dispatch({ type: "ShowEquipmentDetails", data: true });
    const { dispatch, match, shipId } = this.props;
    if (match.path === "/Home/PendingShipDetails/:id") {
      this.props.history.push(
        `/Home/PendingShipDetails/Equipment/${id}/${shipId}`
      );
    } else {
      this.props.history.push(`/Home/ShipDetails/Equipment/${id}/${shipId}`);
    }
    // dispatch(getEquipmentHistory(id));
    // dispatch(getEquipmentServiceTypeList(id));
    // dispatch(getEquipmentInfo(id));
    /*  window.scrollTo(0, 0); */
  };

  getEquipmentInfo = (shipEquipmentId, item) => {
    console.log(item, 'info');

    const { dispatch } = this.props;
    dispatch(getEquipmentInfo(shipEquipmentId));
    this.setState({ modalIsOpen: true });
  };

  downloadDocuments = (item, doctype) => {
    console.log(item, 'info');

    const { dispatch, t } = this.props;
    if (item !== null && item?.length !== 0) {
      this.setState({ downloadArray: item, modalIsOpendownload: true, currentdoctype: doctype });
    }
    else {
      // swal("Information!", "There is no attachment to download.", "info");
      swal({
        title: t('SwalError.Information'),
        text: t('SwalError.NoAttachment'),
        icon: 'info',
        buttons: {
          confirm: {
            text: t('confirmAlertMessage.Ok')
          }
        }
      });
    }
  };

  render() {
    const { currentPage, arraylist, pageSize, equipmentInfo, totalRecords, t } = this.props;

    return (
      <div className="pb-3">
        <Modal
          size="md"
          show={this.state.modalIsOpen}
          onHide={() => this.setState({ modalIsOpen: false })}
          aria-labelledby="example-modal-sizes-title-sm"
          backdrop="static"
          centered="true"
          animation="true"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-sm">
              {t("content.MoreInformation")}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <table style={{ width: "100%" }}>
              <tr>
                <th className="white-border">{t("ShipEquipmentStatusScreen.EquipmentName")}: </th>
                <td className="white-border">
                  {equipmentInfo.equipment ? equipmentInfo.equipment : ""}
                </td>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <th className="white-border">{t("ShipEquipmentStatusScreen.Type")}: </th>
                <td className="white-border">
                  {equipmentInfo.equipmentType
                    ? equipmentInfo.equipmentType
                    : ""}
                </td>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <th className="white-border">{t("ShipEquipmentStatusScreen.Capacity")} /{t("ShipEquipmentStatusScreen.Size")}: </th>
                <td className="white-border">{equipmentInfo.capacity ? equipmentInfo.capacity : ""}</td>
              </tr>
              {equipmentInfo.equipment ? equipmentInfo?.equipment.toLowerCase().includes("lifeboat") ?
                <><tr style={{ lineHeight: "30px" }}>
                  <th className="white-border">{t("EditEquipmentScreenContent.LifeboatMake")} :{" "} </th>
                  <td className="white-border">{equipmentInfo.lifeboatMake ? equipmentInfo.lifeboatMake : ""}</td>
                </tr>
                  <tr style={{ lineHeight: "30px" }}>
                    <th className="white-border">{t("EditEquipmentScreenContent.Davit/winchMake")} :{" "} </th>
                    <td className="white-border">{equipmentInfo.davitwinchMake ? equipmentInfo.davitwinchMake : ""}</td>
                  </tr>
                  <tr style={{ lineHeight: "30px" }}>
                    <th className="white-border">{t("EditEquipmentScreenContent.LifeboatModel")} :{" "} </th>
                    <td className="white-border">{equipmentInfo.lifeboatModel ? equipmentInfo.lifeboatModel : ""}</td>
                  </tr>
                  <tr style={{ lineHeight: "30px" }}>
                    <th className="white-border">{t("EditEquipmentScreenContent.LifeboatRelease")} :{" "}</th>
                    <td className="white-border">{equipmentInfo.lifeboatRelease ? equipmentInfo.lifeboatRelease : ""}</td>
                  </tr></>
                : equipmentInfo?.equipment?.toLowerCase().includes("rescue boat") ?
                  <><tr style={{ lineHeight: "30px" }}>
                    <th className="white-border">{t("EditEquipmentScreenContent.rescueboatMake")} :{" "} </th>
                    <td className="white-border">{equipmentInfo.rescueboatMake ? equipmentInfo.rescueboatMake : ""}</td>
                  </tr>
                    <tr style={{ lineHeight: "30px" }}>
                      <th className="white-border">{t("EditEquipmentScreenContent.rescueboatDavit/winchMake")} :{" "} </th>
                      <td className="white-border">{equipmentInfo.rescueboatdavitwinchMake ? equipmentInfo.rescueboatdavitwinchMake : ""}</td>
                    </tr>
                    <tr style={{ lineHeight: "30px" }}>
                      <th className="white-border">{t("EditEquipmentScreenContent.rescueboatModel")} :{" "} </th>
                      <td className="white-border">{equipmentInfo.rescueboatModel ? equipmentInfo.rescueboatModel : ""}</td>
                    </tr>
                    <tr style={{ lineHeight: "30px" }}>
                      <th className="white-border"> {t("EditEquipmentScreenContent.rescueboatRelease")} :{" "} </th>
                      <td className="white-border">{equipmentInfo.rescueboatRelease ? equipmentInfo.rescueboatRelease : ""}</td>
                    </tr></>
                  : <>
                    <tr style={{ lineHeight: "30px" }}>
                      <th className="white-border">{t("ShipEquipmentStatusScreen.Make")}: </th>
                      <td className="white-border">{equipmentInfo.make ? equipmentInfo.make : ""}</td>
                    </tr>
                    <tr style={{ lineHeight: "30px" }}>
                      <th className="white-border">{t("ShipEquipmentStatusScreen.Model")}: </th>
                      <td className="white-border">{equipmentInfo.model ? equipmentInfo.model : ""}</td>
                    </tr>
                  </>
                : <></>}
              <tr style={{ lineHeight: "30px" }}>
                <th className="white-border">{t("ShipEquipmentStatusScreen.ManufacturingDate")}: </th>
                <td className="white-border">
                  {equipmentInfo.manufracturingDate
                    ? moment(equipmentInfo.manufracturingDate).format(
                      "DD MMM YYYY"
                    )
                    : ""}
                </td>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <th className="white-border">{t("ShipEquipmentStatusScreen.Quantity")}: </th>
                <td className="white-border">{equipmentInfo.quantity ? equipmentInfo.quantity : ""}</td>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <th className="white-border">{t("TopPaneContent.Category")}: </th>
                <td className="white-border">{equipmentInfo.category ? equipmentInfo.category : ""}</td>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <th className="white-border">{t("ShipEquipmentStatusScreen.AdditionalInformation")}: </th>
                <td className="white-border">
                  {equipmentInfo.additionalInformation
                    ? equipmentInfo.additionalInformation
                    : ""}
                </td>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <th className="white-border">{t("content.Servicetype")}: </th>
                <td className="white-border">
                  {equipmentInfo.serviceType ? equipmentInfo.serviceType : ""}
                </td>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <th className="white-border">{t("ShipEquipmentStatusScreen.LastDone")}: </th>
                <td className="white-border">
                  {equipmentInfo.lastDone
                    ? moment(equipmentInfo.lastDone).format("DD MMM YYYY")
                    : ""}
                </td>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <th className="white-border">{t("ShipEquipmentStatusScreen.LastServicePort")}: </th>
                <td className="white-border">
                  {equipmentInfo.lastServicePort
                    ? equipmentInfo.lastServicePort
                    : ""}
                </td>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <th className="white-border">{t("ShipEquipmentStatusScreen.NextServiceDue")}: </th>
                <td className="white-border">
                  {equipmentInfo.nextDue
                    ? moment(equipmentInfo.nextDue).format("DD MMM YYYY")
                    : ""}
                </td>
              </tr>
            </table>
          </Modal.Body>
        </Modal>
        <Modal
          size="md"
          show={this.state.modalIsOpendownload}
          onHide={() => this.setState({ modalIsOpendownload: false, currentdoctype: '' })}
          aria-labelledby="example-modal-sizes-title-smdownload"
          backdrop="static"
          centered="true"
          animation="true"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-smdownload">
              {t(`EquipmentManagementScreenContent.${this.state.currentdoctype}`)}
              {/* {this.state.currentdoctype} */}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.downloadArray.map((item) => {
              return (
                <div className=" card mb-1 px-1 py-1">

                  <div className="row g-0">
                    <div className="col-12 ">
                      <div className="d-flex align-items-center">
                        <span className="grey-background " style={{ color: 'black', fontSize: '13px' }}>{item?.filename}
                          <i
                            className="fa fa-download click px-1 ml-2"
                            aria-hidden="true"
                            onClick={() => { this.props.dispatch(DownloadAttachment(item?.filename, item?.guid)) }}
                            style={{ color: " #1a3464", fontSize: "15px" }}
                          ></i>
                        </span>
                      </div>
                    </div>
                    {/* <div className="col-2">
                      <i
                        className="fa fa-download click px-1"
                        aria-hidden="true"
                        onClick={() => { this.props.dispatch(DownloadAttachment(item?.filename, item?.guid)) }}
                        style={{ color: " #1a3464", fontSize: "1.5rem" }}
                      ></i>
                    </div> */}
                  </div>

                </div>
              );
            })}

          </Modal.Body>
        </Modal>

        {this.renderCardData()}

        {arraylist?.length != 0 ? (
          <Paginator
            first={currentPage}
            rows={pageSize}
            totalRecords={totalRecords}
            onPageChange={(e) => this.onPaginatorChange(e)}
          ></Paginator>
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">
                {t("CommonText.NoItem")}
              </h6>
            </div>
          </div>
        )}
      </div>
    );
  }

  onPaginatorChange(event) {
    this.setState({
      first: event.first,
    });
    const { setUpdatedState } = this.props;
    setUpdatedState(event.page + 1);
  }

  renderCardData = () => {
    const {
      shipId,
      arraylist,
      showEquipmentDetails,
      editShipDetailsPane,
      editEquipmentDetailsPane,
      t
    } = this.props;

    const isArabic = i18n.language === 'arab'

    return arraylist && arraylist.length
      ? arraylist.map((item, index) => {
        return (
          <div
            className="card"
            style={{
              overflow: "hidden",
              position: "relative",
              marginBottom: "5px",
            }}
          >
            <div>
              {item.isOverDue ? (
                <div className="arrow-left-red"></div>
              ) : (
                <div className="arrow-left-green"></div>
              )}
            </div>
            <div className="p-3">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div
                    className={
                      showEquipmentDetails || editEquipmentDetailsPane
                        ? "col-sm-9 col-md-9 col-9 col-m-auto"
                        : "col-sm-10 col-md-10 col-10 col-m-auto"
                    }
                  >
                    <div className="row">
                      <div className="col-sm-12 col-md-12 pb-2 d-flex">
                        <h6
                          className={
                            showEquipmentDetails || editEquipmentDetailsPane
                              ? "resource-list-title"
                              : "resource-list-title"
                          }
                          onClick={() =>
                            this.ShowRightPanel(item.shipEquipmentId)
                          }
                        >
                          {item.equipmentName ? item.equipmentName : ""}
                        </h6>
                        {" "}
                        {/* <span className={`badge badge-light ship-badge ${item?.equipmentContractType?.toLowerCase() == "addon" ? "add-on-badge-light" : item?.equipmentContractType?.toLowerCase() == "adhoc" ? "add-hoc-badge-light" : "mandate-badge-light"} ml-2`}>
                          {item?.equipmentContractType}
                        </span> */}
                        {/* {item.equipmentTypes.map(type=>(
                          <span className={`badge badge-light ship-badge ${type?.equipmentType?.toLowerCase() == "addon" ? "add-on-badge-light" : type?.equipmentType?.toLowerCase() == "adhoc" ? "add-hoc-badge-light":type?.equipmentType?.toLowerCase() == "mandate"? "mandate-badge-light" :"ship-staff-badge-light"} ml-2`}>
                            {type?.equipmentType && `${type.serviceType} - ${type.equipmentType}`}
                            
                            
                            </span>
                        ))                
      } */}

                        {item.equipmentTypes.length > 0 && (
                          <>
                            {Object.entries(
                              item.equipmentTypes.reduce((acc, type) => {
                                const equipmentType = type?.equipmentType?.toLowerCase();
                                const serviceType = type?.serviceType;

                                if (equipmentType && serviceType) {
                                  if (!acc[equipmentType]) {
                                    acc[equipmentType] = new Set();
                                  }
                                  acc[equipmentType].add(serviceType);
                                }
                                return acc;
                              }, {})
                            ).map(([equipmentType, serviceTypesSet]) => {
                              const serviceTypes = Array.from(serviceTypesSet)
                                .map((type) => parseFloat(type.split(' ')[0]))
                                .sort((a, b) => a - b);

                              const formattedServiceTypes = serviceTypes.join(", ");

                              return (
                                <span
                                  key={equipmentType}
                                  className={`badge badge-light ship-badge ${equipmentType === "addon"
                                    ? "add-on-badge-light"
                                    : equipmentType === "adhoc"
                                      ? "add-hoc-badge-light"
                                      : equipmentType === "mandate"
                                        ? "mandate-badge-light"
                                        : "ship-staff-badge-light"
                                    } ml-2`}
                                >
                                  {`${formattedServiceTypes} yearly - ${equipmentType.charAt(0).toUpperCase() + equipmentType.slice(1)}`}
                                </span>
                              );
                            })}
                          </>
                        )}
                      </div>
                      <div
                        className={
                          showEquipmentDetails || editEquipmentDetailsPane
                            ? "col-sm-6 mb-2"
                            : "col-sm-3 mb-2"
                        }
                      >
                        <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                          <strong>{t("ShipEquipmentStatusScreen.Quantity")} </strong>
                          <strong>: </strong>

                        </span>
                        <span className="italicFont">
                          {item.quantity ? item.quantity : ""}
                        </span>
                      </div>
                      <div
                        className={
                          showEquipmentDetails || editEquipmentDetailsPane
                            ? "col-sm-6 mb-2"
                            : "col-sm-3 mb-2"
                        }
                      >
                        <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                          <strong>{t("ShipEquipmentStatusScreen.LastDone")} </strong>
                          <strong>: </strong>

                        </span>
                        <span className="italicFont">
                          {item.lastDone
                            ? moment(item.lastDone).format("DD MMM YYYY")
                            : ""}
                        </span>
                      </div>
                      <div
                        className={
                          showEquipmentDetails || editEquipmentDetailsPane
                            ? "col-sm-6 mb-2"
                            : "col-sm-3 mb-2"
                        }
                      >
                        <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                          <strong>{t("ShipEquipmentStatusScreen.NextServiceDue")} </strong>
                          <strong>: </strong>
                          {/* <i aria-hidden="true"></i> */}
                          {" "}

                        </span>
                        <span className="italicFont">
                          {item.nextDue
                            ? moment(item.nextDue).format("DD MMM YYYY")
                            : ""}
                        </span>
                      </div>
                      <div
                        className={
                          showEquipmentDetails || editEquipmentDetailsPane
                            ? "col-sm-6 mb-2"
                            : "col-sm-3 mb-2"
                        }
                      >
                        <span className={`${isArabic ? 'arabic' : ''}`}>
                          <strong>{t("ShipEquipmentStatusScreen.Capacity")} / {t("ShipEquipmentStatusScreen.Size")} </strong>
                          <strong>:</strong>
                          <span className="italicFont ">
                            {item.capacity ? item.capacity : ""}
                          </span>
                        </span>
                      </div>
                      <div
                        className={
                          showEquipmentDetails || editEquipmentDetailsPane
                            ? "col-sm-6 mb-2"
                            : "col-sm-3 mb-2"
                        }>
                        <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                          <strong>{t("ShipEquipmentStatusScreen.LastDoneServiceType")} </strong>
                          <strong>:</strong>

                        </span>
                        <span className="italicFont ">
                          {item.serviceType ? item.serviceType : ""}
                        </span>
                      </div>
                      <div
                        className={
                          showEquipmentDetails || editEquipmentDetailsPane
                            ? "col-sm-6 mb-2"
                            : "col-sm-3 mb-2"
                        }
                      >
                        <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                          <strong>{t("ShipEquipmentStatusScreen.ApplicableServiceType")} </strong>
                          <strong>:</strong>

                        </span>
                        <span className="italicFont ">
                          {item.applicableServiceTypes
                            ? item.applicableServiceTypes
                            : ""}
                        </span>
                      </div>

                      <div
                        className={
                          showEquipmentDetails || editEquipmentDetailsPane
                            ? "col-sm-6 mb-2"
                            : "col-sm-3 mb-2"
                        }
                      >
                        <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                          <strong>{t("ShipEquipmentStatusScreen.NextApplicableServiceType")}</strong>
                          <strong>:</strong>

                        </span>
                        <span className="italicFont ">
                          {item.nextApplicableServiceType
                            ? item.nextApplicableServiceType
                            : ""}
                        </span>
                      </div>

                      <div
                        className={
                          showEquipmentDetails || editEquipmentDetailsPane
                            ? "col-sm-6 mb-2"
                            : "col-sm-3 mb-2"
                        }
                      >
                        <span>
                          <strong>{t("ShipEquipmentStatusScreen.Tobeperformed")}: </strong>
                          <span className="italicFont ">
                            {item.nextServiceCanBePerformedBy
                              ? item.nextServiceCanBePerformedBy
                              : ""}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  {editShipDetailsPane ? (
                    <div
                      className={
                        editEquipmentDetailsPane
                          ? "col-sm-2 col-md-2 col-lg-2 text-center col-m-auto"
                          : "col-sm-2 col-md-2 col-lg-2 text-center col-m-auto"
                      }
                    >
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={this.renderView()}
                      >
                        <i
                          className="fa fa-edit click"
                          aria-hidden="true"
                          onClick={() =>
                            this.editEquipmentDetails(item, shipId)
                          }
                          style={{ color: " #1a3464", fontSize: "2em" }}
                        ></i>
                      </OverlayTrigger>
                    </div>
                  ) : (
                    <div
                      className={
                        showEquipmentDetails
                          ? "col-sm-3 col-md-3 col-m-auto "
                          : "col-sm-2 col-md-2 col-m-auto "
                      }
                    >
                      <div
                        className="ml0 text-center"
                        style={
                          showEquipmentDetails
                            ? { marginLeft: "1rem", marginTop: "2rem" }
                            : { marginLeft: "1.5rem", marginTop: "1rem" }
                        }
                      >
                        <OverlayTrigger
                          className="click px-1"
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={this.renderMPopover()}
                        >
                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 75 75"
                            xmlns="http://www.w3.org/2000/svg"
                            className="micon-space pointer-cursor"
                            onClick={() => this.downloadDocuments(item.equipmentManual, "EquipmentManual")}
                          >
                            <circle cx="30" cy="30" r="28" fill="#1a3464" />
                            <text
                              x="30"
                              y="34"
                              font-family="Arial, sans-serif"
                              font-size="40"
                              fill="#FFFFFF"
                              text-anchor="middle"
                              dominant-baseline="middle"
                            >
                              M
                            </text>
                          </svg>
                        </OverlayTrigger>
                        <OverlayTrigger
                          className="click px-1"
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={this.renderWPopover()}
                        >
                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 75 75"
                            xmlns="http://www.w3.org/2000/svg"
                            className="micon-space pointer-cursor"
                            onClick={() => this.downloadDocuments(item.workProcedure, "Workprocedure")}
                          >
                            <circle cx="30" cy="30" r="28" fill="#1a3464" />
                            <text
                              x="30"
                              y="34"
                              font-family="Arial, sans-serif"
                              font-size="40"
                              fill="#FFFFFF"
                              text-anchor="middle"
                              dominant-baseline="middle"
                            >
                              W
                            </text>
                          </svg>
                        </OverlayTrigger>
                        <OverlayTrigger
                          className="click px-1"
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={this.renderGPopover()}
                        >
                          <img
                            width="30"
                            height="25"
                            src={Guideline}
                            className="click"
                            style={{ marginBottom: "10px" }}
                            onClick={() => this.downloadDocuments(item.guideLines, "GuideLines")}
                          ></img>
                        </OverlayTrigger>
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={this.renderPopover()}
                        >
                          <i
                            className="fa fa-download click px-1"
                            aria-hidden="true"
                            onClick={() => this.downloadStatus(item)}
                            style={{ color: " #1a3464", fontSize: "1.5rem" }}
                          ></i>
                        </OverlayTrigger>
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={this.renderPopover2()}
                        >
                          <i
                            className="fa fa-info-circle click px-1"
                            aria-hidden="true"
                            style={{ color: " #1a3464", fontSize: "1.65rem" }}
                            onClick={() =>
                              this.getEquipmentInfo(item.shipEquipmentId, item)
                            }
                          ></i>
                        </OverlayTrigger>
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={this.renderViewequip()}
                        >
                          <i
                            className="fa fa-eye click px-1"
                            aria-hidden="true"
                            style={{ color: " #1a3464", fontSize: "1.75rem" }}
                            onClick={() =>
                              this.ShowRightPanel(item.shipEquipmentId, item)
                            }
                          ></i>
                        </OverlayTrigger>
                      </div>
                      {item.manualName && (
                        <div
                          class="col-sm-12 text-center py-1"
                          style={{ color: "#fff", width: "auto" }}
                        >
                          <button
                            class="btn btn-secondary btn-xs btn-conf-edit customBtn2"
                            id={`popover${index}`}
                            onClick={() => this.downloadWorkProcedure(item)}
                          >
                            <i class="glyphicon glyphicon-remove"></i>{" "}
                            {t("ShipEquipmentStatusScreen.Downloadworkprocedure")}
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })
      : null;
  };

  downloadStatus = (item) => {
    const { dispatch } = this.props;
    dispatch(DownloadAttachment(item.attachmentName, item.attachmentGuid));
  };
  downloadGuide = (item) => {
    const { dispatch } = this.props;
    dispatch(DownloadAttachment(item.guideName, item.guideGuid));
  };
  downloadEquipManual = (item) => {
    const { t } = this.props;
    const attachmentName = item?.otherAttachmentName ? item?.otherAttachmentName : "";
    const attachmentGuid = item?.otherAttachmentGuid ? item?.otherAttachmentGuid : "";
    if (attachmentName != "") {
      this.props.dispatch(DownloadAttachment(attachmentName, attachmentGuid));
    } else {
      // swal("Information!", "There is no attachment to download.", "info")
      swal({
        title: t('SwalError.Information'),
        text: t('SwalError.NoAttachment'),
        icon: 'info',
        buttons: {
          confirm: {
            text: t('confirmAlertMessage.Ok')
          }
        }
      });
    }
    if (item.equipmentManual !== null) {

    }
    else {
      // swal("Information!", "There is no attachment to download.", "info");
      swal({
        title: t('SwalError.Information'),
        text: t('SwalError.NoAttachment'),
        icon: 'info',
        buttons: {
          confirm: {
            text: t('confirmAlertMessage.Ok')
          }
        }
      });
    }
  };
  downloadWorkProcedure = (item) => {
    const { dispatch } = this.props;
    dispatch(DownloadAttachment(item.manualName, item.manualGuid));
  };

  ShowSidePanel = (id) => {
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.history.push(`/Home/EquipmentEdit/${id}/single`);
  };

  editEquipmentDetails = (equipmentDetail, shipId) => {
    console.log(equipmentDetail);

    // const { dispatch } = this.props;
    // dispatch({ type: "EditEquipmentDetails", data: true });
    // dispatch({ type: "EquipmentDetail", data: equipmentDetail });
    // this.props.history.push(`/Home/ShipDetails/EquipmentEdit/${equipmentDetail.shipEquipmentId}/${type}`);
    this.props.dispatch({ type: "GET_SERVICEUPDATE_EQUIPMENTTYPE", data: equipmentDetail?.equipmentContractType })
    this.props.history.push(
      `/Home/EquipmentServiceTypes/${shipId}/${equipmentDetail.shipEquipmentId}`
    );
  };
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    PrevPos: state.SidePanReducer.PrevPos,
    //BY BALU MOORTHI
    showEquipmentDetails: state.SidePanReducer.ShowEquipmentDetails || false,
    equipmentInfo: state.ShipEquipmentReducer.EquipmentInfo || {},
    editShipDetailsPane: state.SidePanReducer.EditShipDetails || false,
    editEquipmentDetailsPane:
      state.SidePanReducer.EditEquipmentDetails || false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EquipmentCard))
);
